import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest,HttpResponse,HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  private API=environment.apiURL
  constructor(private http:HttpClient) { }

  getTemplateDetailsByMerchantId(merchantId){
    let header = new HttpHeaders().set(
      "Authorization",
      localStorage.getItem("apiKey")
    );
    return this.http.get<any>(environment.apiURL+'/merchants/'+merchantId+'/templates',{headers:header})
  }

  getTemplateByName(merchantId, name) {
    return this.http.get<any>(environment.apiURL+'/merchants/'+merchantId+'/templates/'+name);
  }

  createTemplate(data){
    let merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
    return this.http.post(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/templates`,data, { responseType: 'text'})
  }

  deleteTemplate(TemplateName){
    const merchant_id =  JSON.parse(localStorage.getItem('loginUserDetails'));
    return this.http.delete(`${environment.apiURL}/merchants/${merchant_id.merchant_id}/templates/${TemplateName}`, { responseType: 'text'})
  }

}